import { PayloadAction } from '@reduxjs/toolkit';

import { OnBoardingState } from '../reducers';

export const changeCurrentStep = (state: OnBoardingState, action: PayloadAction<{ id: string, question: string} | null>) => {
  state.currentStep = action.payload
};
